export default __webpack_public_path__ + "static/media/DoctorRequestApproval.30c7022e.svg";